import { useMutation } from "@tanstack/react-query";
import { payFee, CreateOrderResponse, OrderRequestDto } from "../services/paymentService";

export function usePayment() {
  // Mutation to pay fee
  const createOrderMutation = useMutation<CreateOrderResponse, Error, OrderRequestDto>({
    mutationFn: payFee,
  });

  return {
    createOrderMutation,
  };
}

